module.exports = __webpack_public_path__ + "img/rightarrow.b88ee64e.png";